module.exports = __webpack_public_path__ + "static/media/android.b2ff1946.jpg";